export default __webpack_public_path__ + "static/media/wm1.5ce988b9.jpg";